export enum Direction {
  BORROW = 'BORROW',
  LEND = 'LEND'
}
